import Vue from 'vue'
import Router from 'vue-router'
import { pubRoutes, sysRoutes ,mergeRoutes} from './config'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { smpRoutes } from './smp'
import { erpRoutes } from './erp'
import { pdRoutes } from './pd'
import { smRoutes } from './sm'
import { alarmRoutes } from './alarm'

Vue.use(Router)
//处理多次导航到同一地址报错
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

let allRoutes = pubRoutes.concat(sysRoutes);
mergeRoutes(allRoutes,'desktop',smpRoutes);
mergeRoutes(allRoutes,'desktop',erpRoutes);
mergeRoutes(allRoutes,'desktop',pdRoutes);
mergeRoutes(allRoutes,'desktop',smRoutes);
mergeRoutes(allRoutes,'desktop',alarmRoutes);
const router = new Router({
	mode:'history',
	routes: allRoutes,
    base: process.env.NODE_ENV === 'production' ? '/' : '/'
});

router.beforeEach((to, from, next) => {
	NProgress.start()
    next()
});
 
router.afterEach((to,from) => {
    NProgress.done();
});

//路由名到路由的map
let routeNameMap= new Map();
//路由组件到路由的map
let routeCompMap= new Map();

function genRouteMap(routes,parentRoute,nameMap,compMap){
    for(var idx in routes){
        let route = routes[idx];
        if(!route.meta)
            route.meta = {};

        route.meta.parentRoute = parentRoute;

        nameMap.set(route.name,route);

        if(route.meta.compPath){
            let compRoutes = compMap.get(route.meta.compPath);
            if(!compRoutes){
                compRoutes = [];
                compMap.set(route.meta.compPath,compRoutes);
            }
            compRoutes.push(route);
        }
        if(route.children)
            genRouteMap(route.children,route,nameMap,compMap);
    }
}

//立即创建路由MAP
genRouteMap(allRoutes,null,routeNameMap,routeCompMap);

export function findRouteByCompPath(compPath){
    return routeCompMap.get(compPath);
}

export function findRouteByRouteName(routeName){
    return routeNameMap.get(routeName);
}
 
export default router;
